import Link from 'next/link';

import { cn } from '@app/libs/utils';

import ArrowDownIcon from '../icons/ArrowDownIcon';

interface BreadcrumbProps {
  className?: string;
  showHome?: boolean;
  separator?: string | React.ReactNode;
  items: {
    label: string;
    href: string;
  }[];
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  className,
  showHome = true,
  separator = <ArrowDownIcon className="w-4 h-4 rotate-270" />,
  items,
}) => {
  return (
    <div className={cn('flex flex-nowrap items-center gap-2', className)}>
      <div className="flex flex-nowrap items-center gap-2 overflow-hidden">
        {showHome && (
          <Link href="/">
            <span className="text-nowrap">Trang chủ</span>
          </Link>
        )}
        {separator && items.length > 1 && <span className="opacity-20">{separator}</span>}
        {items.slice(0, -1).map(item => (
          <Link key={item.href} href={item.href} className="text-nowrap">
            {item.label}
          </Link>
        ))}
        {separator && <span className="opacity-20">{separator}</span>}
        <span className="opacity-50 text-truncate text-ellipsis line-clamp-1">
          {items[items.length - 1].label}
        </span>
      </div>
    </div>
  );
};
